export const apiGetAllOrderB2B = `/1.0/wsm/leader/order/list`
export const apiDetailOrderB2B = id => `/1.0/wsm/leader/order/${id}/detail`
export const apiCreateOrderB2B = `/1.0/wsm/leader/order/create`
export const apiUpdateOrderB2B = id => `/1.0/wsm/leader/order/${id}/update`
// export const deleteOrderB2B = `wsm/leader/order/delete`;
export const apiBrowseOrderB2B = id => `/1.0/wsm/leader/order/${id}/browse`
export const apiRefuseOrderB2B = id => `/1.0/wsm/leader/order/${id}/refuse`
export const apiGetAllHistoryOrderB2B = `/1.0/wsm/leader/export/list`
export const apiDetailHistoryOrderB2B = id => `leader/export/${id}/detail`

export const apiGetPriceSim = "/1.0/wsm/setting/list/price"
export const apiGetPackageListAll = "/1.0/wsm/package/listall"

export const apiGetPackageList = `/1.0/wsm/leader/package/list`
export const apiGetOrderAgency = `/1.0/wsm/agency/order/list`
export const apiCreateOrderAgency = `/1.0/wsm/agency/order/create`
export const apiUpdateOrderAgency = id => `/1.0/wsm/agency/order/${id}/update`
export const apiGetOrderAgencyChild = `/1.0/wsm/agency/order/list-child`
export const apiBrowseOrderAgencyChild = id =>
  `/1.0/wsm/agency/order/${id}/browse`
export const apiRefuseOrderAgencyChild = id =>
  `/1.0/wsm/agency/order/${id}/refuse`
export const apiBrowseOrderAgencyByParent = id =>
  `/1.0/wsm/agency/order/${id}/browse-by-parent`
export const apiRefuseOrderAgencyByParent = id =>
  `/1.0/wsm/agency/order/${id}/refuse-by-parent`

//setting package price
export const apiGetPackagePrice = `/1.0/wsm/leader/priceSetting/list`
export const apiCreatePackagePrice = `/1.0/wsm/leader/package-setting/create`
export const apiGetListUserDiscount = `/1.0/wsm/setting/listCommission`
export const apiUpdateUserPrice = `/1.0/wsm/setting/updateCommission`
export const apiGetPackagePriceDetail = id =>
  `/1.0/wsm/leader/priceSetting/${id}/listChild`
export const apiSetOverridePackagePrice = `/1.0/wsm/leader/priceSetting/setOverride`
export const apiSetBasePackagePrice = `/1.0/wsm/leader/priceSetting/addMaster`
export const apiSetCommission = `/1.0/wsm/leader/priceSetting/setCommission`

//buy package group
export const apiGetBoughtPackage = `/1.0/wsm/package/get/bought`

export const apiGetPackageHistory = `/1.0/wsm/leader/package-setting/detail`
export const apiSearchBuyData = `/1.0/wsm/Buy/Data/search`
export const apiPullBuyData = `/1.0/wsm/Buy/Data/pull`
export const apiListPackageSaleType = `/1.0/wsm/leader/priceSetting/listAll`
export const apiChooseModePackageSaleType = `/1.0/wsm/leader/priceSetting/chooseMode`
